import {URL} from '../Helper/helper';

export const invokeReservations = async() =>{
    const perbookingsData = await fetch(`${URL}`+'/perbookings')
    const perbookingResponse = await perbookingsData.json()

    return  perbookingResponse;
}
export const invokeBookings = async() =>{
    const bookingsData = await fetch(`${URL}`+'/bookings')
    const bookingResponse = await bookingsData.json()
    //console.log('Bookings Response',bookingResponse)
    let todays_date = formatDate(new Date())
    const current_booking_resp = bookingResponse.filter(date => date.booking_date >= todays_date)
    return bookingResponse;//current_booking_resp;
}

export const invokeCancelDates = async() =>{
    const cancel_dates_Data = await fetch(`${URL}`+'/canceldates')
    const cancelDatesResponse = await cancel_dates_Data.json()
    return cancelDatesResponse;
}

export const invokeTrainers = async() =>{
    const trainersData = await fetch(`${URL}`+'/trainers/getTrainers')
    const trainersDataResponse = await trainersData.json()
    return trainersDataResponse;
}

export const invokeGallery = async() =>{
    const galleryData = await fetch(`${URL}`+'/gallery/getgallery')
    const galleryDataResponse = await galleryData.json()
    return galleryDataResponse;
}
export const invokeTermDates = async() =>{
    const termdatesData = await fetch(`${URL}`+'/term/termdates')
    const termdatesResponse = await termdatesData.json()
    return termdatesResponse;
}

export const invokeServices = async() =>{
    const servicesData = await fetch(`${URL}`+'/services/services')
    const servicesResponse = await servicesData.json()
    return servicesResponse;
}

export const invokeSquad = async() =>{
    const squadData = await fetch(`${URL}`+'/squad/squads')
    const squadResponse = await squadData.json()
    return squadResponse;
}

export const invokeSquadInfo = async() =>{
    const squadInfoData = await fetch(`${URL}`+'/squadinfo/squadinfo')
    const squadInfoResponse = await squadInfoData.json()
    return squadInfoResponse;
}

export const invokeDisclaimer = async() =>{
    const disclaimerData = await fetch(`${URL}`+'/disclaimer/disclaimer')
    const disclaimerResponse = await disclaimerData.json()
    return disclaimerResponse;
}

export const invokeHolidays = async() =>{
    const holidayData = await fetch(`${URL}`+'/holiday/holidays')
    const holidayResponse = await holidayData.json()
    return holidayResponse;
}

export const invokeFailedBookings = async() =>{
    try {
        // First try to fetch all failed bookings from dedicated endpoint
        const failedBookingsData = await fetch(`${URL}/failed-bookings`)

        const {data,success} = await failedBookingsData.json()
        if(success){
            return data;
        }
        else{
            throw new Error('Failed to fetch failed bookings');
        }
    } catch (error) {
        console.error('Error fetching failed bookings:', error);
        throw error;
    }
}

export const invokeDeletedBookings = async() =>{
    try {
        console.log('Attempting to fetch deleted bookings from:', `${URL}/deleted-bookings`);
        const deletedBookingsData = await fetch(`${URL}/deleted-bookings`)
        console.log('Raw response for deleted bookings:', deletedBookingsData);
        if (!deletedBookingsData.ok) {
            const errorBody = await deletedBookingsData.text();
            throw new Error(`Failed to fetch deleted bookings: ${deletedBookingsData.status} ${deletedBookingsData.statusText} - ${errorBody}`);
        }
        const deletedBookingsResponse = await deletedBookingsData.json()
        console.log('Parsed response for deleted bookings:', deletedBookingsResponse);
        return deletedBookingsResponse;
    } catch (error) {
        console.error('Error fetching deleted bookings:', error);
        throw error;
    }
}

export const formatDate = (date) =>{
    var year = date?.toLocaleString("default", { year: "numeric" });
    var month = date?.toLocaleString("default", { month: "2-digit" });
    var day = date?.toLocaleString("default", { day: "2-digit" });
    // Generate yyyy-mm-dd date string
    var formattedDate = year + "-" + month + "-" + day;
    return formattedDate;
}

export const sendBookingConfirmationEmail = async (bookingDetails) => {
    try {
        const options = {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify(bookingDetails)
        };
        const response = await fetch(`${URL}/email-notifications/send-success-email`, options);
        if (response.ok) {
            console.log('Booking confirmation email sent successfully');
            return true;
        } else {
            console.error('Failed to send booking confirmation email. Status:', response.status, 'Status Text:', response.statusText);
            return false;
        }
    } catch (error) {
        console.error('Error sending booking confirmation email:', error);
        return false;
    }
}